import { Alert, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Register() {
  return (
    <Container
      maxWidth="sm"
      sx={{ flex: 1, display: 'flex', alignItems: 'center', py: { xs: 4, sm: 6 } }}
    >
      <Card sx={{ width: '100%' }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 }, '&:last-child': { pb: { xs: 3, sm: 4 } } }}>
          <Stack spacing={2.25}>
            <Stack spacing={0.75}>
              <Typography variant="h5" color="primary.dark">
                账号申请暂未开放
              </Typography>
              <Typography variant="body2" color="text.secondary">
                当前生产站点仅允许已开通账号登录。需要访问请联系管理员。
              </Typography>
            </Stack>
            <Alert severity="info">公开注册入口已关闭。</Alert>
            <Button component={RouterLink} to="/login" variant="contained" size="large">
              返回登录
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
